import React, { FC, useCallback, useEffect, useRef } from "react";
import cx from "classnames";
import { StructuredText } from "react-datocms";
import { DatoFaqFragment } from "services/datocms/generated";

export type FaqType = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  answer?: any;
  question?: string | null;
};

type Props = {
  datoFaqContent?: DatoFaqFragment[];
  faqs?: FaqType[];
  isLightBg?: boolean;
  onFaqClick: (val: number) => void;
  selectedFaq: number;
};

export const Faqs: FC<Props> = ({
  datoFaqContent,
  faqs,
  isLightBg,
  onFaqClick,
  selectedFaq,
}) => {
  const addDataEventIncludeToChildren = useCallback((parent: HTMLElement) => {
    for (let i = 0; i < parent.children.length; i++) {
      const childElement = parent.children[i] as HTMLElement;
      childElement.setAttribute("data-event-include", "");
      addDataEventIncludeToChildren(childElement);
    }
  }, []);

  const addDataEventInclude = useCallback(() => {
    if (faqsRef) {
      for (const currentRef of faqsRef.current) {
        if (currentRef) addDataEventIncludeToChildren(currentRef);
      }
    }
  }, [addDataEventIncludeToChildren]);

  useEffect(() => {
    addDataEventInclude();
  }, [addDataEventInclude]);

  const faqsRef = useRef<(HTMLLIElement | null)[]>([]);
  const mappedFaqs: FaqType[] | undefined = datoFaqContent
    ? datoFaqContent.map((item) => ({
        question: item.question,
        answer: item.answer?.value,
      }))
    : faqs;

  return (
    <div
      className={cx("faq-list", isLightBg ? "isLightBg" : "")}
      style={{ display: "block" }}
    >
      <ul>
        {mappedFaqs?.map((faq, idx) => {
          const { answer = "", question = "" } = faq;
          const accordionId = `accordion-${idx + 1}`;
          const isSelectedFaq = selectedFaq === idx;

          return (
            <li
              className={cx(
                "accordian",
                isLightBg ? "isLightBg" : "",
                selectedFaq === idx ? "activefaq" : ""
              )}
              data-element-action={`${isSelectedFaq ? "show" : "hide"}`}
              data-element-block="footer"
              data-element-item={`faq|${question}`}
              data-element-name="accordion"
              data-element-type="container"
              data-link_id={accordionId}
              data-link_text={question}
              data-track-event="click"
              key={question}
              onClick={() => onFaqClick(idx)}
              ref={(el) => {
                faqsRef.current[idx] = el;
              }}
            >
              <h2 className={cx(isLightBg ? "isLightBg" : "", "faq-title")}>
                {" "}
                {question}
                <span className="accordion-plus">+</span>
                <span className="accordion-min">–</span>
              </h2>
              <div
                className={cx(
                  "faq-description-wrapper",
                  isSelectedFaq ? "full" : ""
                )}
              >
                <div className={cx("faq-description")}>
                  {datoFaqContent ? (
                    <StructuredText data={answer} />
                  ) : (
                    <div>{answer}</div>
                  )}
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
